<template>
  <sweet-modal ref="modal" icon="warning" hide-close-button>
    <p>
      <StrongI18n
        keypath="modals.template_not_saved"
        :values="{propName: templateName}"
      />
    </p>
    <p>{{ $t('modals.unsaved_work') }}</p>
    <template #button>
      <button class="btn btn-default right-margin" @click="close">
        {{ $t('modals.close_button') }}
      </button>
      <back-to-work-button class="btn btn-primary" />
      <button class="btn btn-danger" @click="openNewTemplate">
        {{ $t('modals.open_selected_template') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import BackToWorkButton from '../BackToWorkButton.vue';
import StrongI18n from '../lang/StrongI18n.vue';

export default {
  name: 'UnsavedTemplateModal',
  components: {
    SweetModal,
    BackToWorkButton,
    StrongI18n
  },
  data: function () {
    return {
      selectedTemplate: {}
    };
  },
  computed: mapState({
    templateName: state => state.templateName
  }),
  methods: {
    ...mapMutations(['setCurrentTemplate']),
    ...mapActions(['retrieveTemplate']),
    openNewTemplate: function () {
      this.$refs.modal.close();
      this.setCurrentTemplate('');
      this.retrieveTemplate(this.selectedTemplate);
    },
    open: function (t) {
      this.selectedTemplate = t;
      this.$refs.modal.open();
    },
    close: function () {
      this.$refs.modal.close();
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
